import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { BackendDataShape, UsedAPI } from "api/config";
import CookieMonster from "api/CookieMonster";

export const letterPositionStoreAPI = createApi({
  reducerPath: "letterPositionStoreAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: `${UsedAPI}`,
    prepareHeaders: (headers) => {
      let token = CookieMonster.loadCookie("jwt");
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["LetterPositionList"],
  endpoints: (builder) => {
    return {
      getLetterPosition: builder.query<string[], object>({
        query: () => {
          let type = "POSITION";
          let url = `/lov?type=${type}`;
          return {
            url,
            method: "GET",
          };
        },
        transformResponse: (response: BackendDataShape<string[]>) =>
          response.data,
        providesTags: ["LetterPositionList"],
      }),
    };
  },
});

export const {
  useGetLetterPositionQuery,
  util: { resetApiState: resetLetterPositionStoreAPI },
} = letterPositionStoreAPI;
